module.exports = __webpack_public_path__ + "img/隨緣自強2.5 的副本.1ed10223.jpg";